function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "FamilyLandingPage_svg__a"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "SourceGraphic",
  stdDeviation: 40
})));
var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "gradient bkgrd",
  transform: "translate(-2392 -3211)",
  opacity: 0.75,
  filter: "url(#FamilyLandingPage_svg__a)"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 7874"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2286",
  d: "M2300.69 3633.494c-34.23-89.252 174.001-527.123 368.138-542.864s423.498 340.915 457.729 430.164 354.71-245.876 160.576-230.14-952.21 432.091-986.442 342.84z",
  fill: "#a1dbd3",
  opacity: 0.636
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2287",
  d: "M3342.708 3535.321c95.797 53.946 159.52 302.858 175.894 385.896s-653.701-38.437-749.5-92.383 418.964-19.934 402.59-102.972 75.22-244.487 171.016-190.54z",
  fill: "#00a68d",
  opacity: 0.799
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2288",
  d: "M2534.149 3513.318c87.179-148.809 479.298-242.088 609.98-265.546s-77.8 1024.282-164.983 1173.09-20.044-657.66-150.724-634.207-381.448-124.525-294.273-273.337z",
  fill: "#00a68d",
  opacity: 0.476
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2289",
  d: "M3066.35 3623.206c147.537-24.42 344.725-312.964 404.26-411.496s-853.472-254.81-1001.007-230.393 526.276 220.281 466.737 318.813-17.525 347.492 130.01 323.076z",
  fill: "#e8f6f4",
  opacity: 0.759
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2290",
  d: "M3747.262 3000.344c-94.927-11.608-469.52 296.588-437.772 488.847s433.507 328.498 528.432 340.105-152.743 403.872-184.495 211.617 188.762-1028.961 93.835-1040.57z",
  fill: "#00a68d",
  opacity: 0.32
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2291",
  d: "M3085.636 2450.12c-164.553 51.476-343.554 412.482-395.778 534.51s1015.263 154.438 1179.817 102.962-636.136-167.346-583.918-289.372-35.568-399.576-200.121-348.1z",
  fill: "#00a68d",
  opacity: 0.476
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2292",
  d: "M2599.378 4333.917c-142.382-97.396-208.025-495.175-222.29-627.208s1016.577 149.278 1158.96 246.674-657.609-26.004-643.35 106.027-150.938 371.903-293.32 274.507z",
  fill: "#a1dbd3",
  opacity: 0.476
})));
var SvgFamilyLandingPage = function SvgFamilyLandingPage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1366,
    height: 769
  }, props), _ref, _ref2);
};
export default SvgFamilyLandingPage;